import { db } from '@/firebase'

const vehicleRef = db.collection('vehicles')

export default {
  state: {
    isVehicleBtnLoading: false
  },
  mutations: {
    toggleVehicleBtnLoading (state, payload) {
      if (payload === undefined || payload === null) {
        state.isVehicleBtnLoading = !state.isVehicleBtnLoading
      } else {
        state.isVehicleBtnLoading = payload
      }
    }
  },
  actions: {
    createVehicle ({ commit }, payload) {
      return vehicleRef.add(payload)
    },
    getVehicles ({ commit }) {
      return vehicleRef.get()
    },
    getVehicleDetail ({ commit }, id) {
      return vehicleRef.doc(id).get()
    },
    updateVehicleDetail ({ commit }, { id, ...payload }) {
      return vehicleRef.doc(id).set(payload, { merge: true })
    },
    deleteVehicle ({ commit }, id) {
      return vehicleRef.doc(id).delete()
    }
  },
  getters: {
    isVehicleBtnLoading: (state) => state.isVehicleBtnLoading
  }
}
